import { useParams } from "react-router-dom";
import { modulesData } from "../../data/hospitalModules";
import PageStructure from "./PageStructure";
import PageStructure2 from "./PageStructure2";
import PageStructure3 from "./PageStructure3";

export default function ModulePage() {
  const { serviceType } = useParams();
  console.log("URL SERVICE TYPE:", serviceType);
  const data = modulesData[serviceType];
  console.log("MODULE DATA:", data);

  if (!data){
    return (
      <h2 className="text-center py-5 text-danger">
        Module &quot;{serviceType}&quot; Not Found
      </h2>
    );
  }
 // ✅ STRUCTURE MAP (Senior-level approach)
  const STRUCTURE_MAP = {
    structure1: PageStructure,
    structure2: PageStructure2,
    structure3: PageStructure3,
  };

  // Fallback to default structure
  const StructureComponent =
    STRUCTURE_MAP[data.structure] || PageStructure;

  return <StructureComponent data={data} />;
}


